module.exports = __webpack_public_path__ + "static/img/Logo-AFCwave-footer.006e757.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logo-AFCwave-footer.png
// module id = cGOK
// module chunks = 39